import { render } from "./LecturesHeader.vue?vue&type=template&id=17991af3"
import script from "./LecturesHeader.vue?vue&type=script&lang=js"
export * from "./LecturesHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__